import './BrandLogo.css';
import { BRAND_LOGO } from './logoAsset';

/**
 * A logo no `h1` da marca (ORD-F-022, item 3): `<picture>` com AVIF e WebP em 1x e 2x, `width`/`height` fixos (sem
 * deslocamento) e sem carga preguiçosa (está no topo). O nome do produto (VITE_PRODUCT_NAME) é o `alt`, e por isso o
 * nome acessível do `h1` segue sendo o do produto.
 */
export function BrandLogo() {
  return (
    <picture class="brand-logo" data-testid="brand-logo">
      <source type="image/avif" srcSet={BRAND_LOGO.avif} />
      <img
        class="brand-logo__img"
        src={BRAND_LOGO.src}
        srcSet={BRAND_LOGO.webp}
        width={BRAND_LOGO.width}
        height={BRAND_LOGO.height}
        alt={import.meta.env.VITE_PRODUCT_NAME}
        decoding="async"
      />
    </picture>
  );
}
